import { useCallback, useEffect, useState } from "react";
import { DashboardService } from "../../../services/dashboard";
import _ from "lodash";

export const useFetchDataForTwoLines = (
  granularity: number,
  isRecalculated: boolean,
  kpiCodes: string[],
  getFormattedItem: (item: any, kpi: any) => any,
) => {
  const [data, setData] = useState<any[]>([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(async () => {
    try {
      setIsLoading(true);

      const res: any = await DashboardService.fetchHistory({
        granularity,
        kpiCodes,
      });

      const result: any = res.map((item: any) =>
        item.kpiValues.map((kpi: any) => getFormattedItem(item, kpi)),
      );

      setData(_.flatten(result).reverse());

      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  }, [getFormattedItem, granularity, kpiCodes]);

  useEffect(() => {
    fetchData();
  }, [fetchData, isRecalculated]);

  return { data, isLoading };
};
